import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { railWidthCollapsed } from '@/theme/customTheme';
import { fontScale } from '@/theme';

export const useNavRailSubItemStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    minHeight: '2rem',
    color: tokens.colorNeutralForeground1,
    textDecorationLine: 'none',
    ...shorthands.padding(tokens.spacingVerticalXXS, '0'),
    ...shorthands.gap('0'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    cursor: 'pointer',
    boxSizing: 'border-box',
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '-2px',
    },
  },
  rootActive: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
  iconColumn: {
    flexShrink: 0,
    width: railWidthCollapsed,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: tokens.spacingHorizontalS,
  },
});
